import { render } from "./SystemValidationButtonSettingsForm.vue?vue&type=template&id=227b04f2&scoped=true&ts=true"
import script from "./SystemValidationButtonSettingsForm.vue?vue&type=script&lang=ts"
export * from "./SystemValidationButtonSettingsForm.vue?vue&type=script&lang=ts"

import "./SystemValidationButtonSettingsForm.vue?vue&type=style&index=0&id=227b04f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227b04f2"]])

export default __exports__